import { render } from "./AddPermission.vue?vue&type=template&id=d300b24e&scoped=true"
import script from "./AddPermission.vue?vue&type=script&lang=js"
export * from "./AddPermission.vue?vue&type=script&lang=js"

import "./AddPermission.vue?vue&type=style&index=0&id=d300b24e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d300b24e"]])

export default __exports__